import moment from 'moment/moment';

/*------------------- COMPONENTS ----------------------*/
Vue.component('patient-info', {
    props: {
        results: Object
    },
    template: `
                <div>
                    <div class="d-flex  flex-wrap">
                        <div class="form-group flex-grow-1 basis-6">
                            <label for="">Module</label>
                            <div type="text" name="location" id="location" class="static form-control" >{{results.procedure}}</div>
                        </div>
                        <div class="form-group flex-grow-1 basis-6">
                            <label for="location">Location</label>
                            <div type="text" name="location" id="location" class="static form-control" >
                                {{ trimmedLocationIdentifier }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex  flex-wrap">
                        <div class="form-group flex-grow-1 basis-6">
                            <label for="patient-identifier">Patient Identifier</label>
                            <div  type="text" class="static form-control" id="patient-identifier" >{{results.patient_identifier}}</div>
                        </div>

                        <div class="form-group flex-grow-1 basis-3">
                            <label for="date-of-birth">Date of Birth</label>
                            <div type="date" class="static form-control required" id="date-of-birth">{{results.date_of_birth | formatDate}}</div>
                        </div>
                        <div class="form-group flex-grow-1 basis-3">
                            <label for="date-of-surgery">Date of Surgery </label>
                            <div type="date" class="static form-control" id="date-of-surgery">{{results.procedure_date | formatDate}}</div>
                        </div>
                    </div>
                </div>
    `,
    filters: {
        formatDate: function (value) {
            return (typeof value === "undefined") ? '' : new Date(value.replace(/-/g, '/')).toLocaleDateString();
        }
    },
    computed: {
        trimmedLocationIdentifier () {
            if (!this.results.location_identifier) {
                return '';
            }

            var maxNameLength = 44;
            var nameLength = this.results.location_identifier.length;
            var tail = '';

            if (nameLength > maxNameLength) {
                nameLength = this.results.location_identifier.substring(0, maxNameLength).lastIndexOf(" ");
                tail = '...';
            }

            return this.results.location_identifier.substring(0, nameLength) + tail;
        }
    },
});

Vue.component('survey-status', {
    mixins: [
    ],
    props: {
        result: Object
    },
    data() {
        return {
            severity: [
                "Normal Result",
                "Mild Result",
                "Moderate Result",
                "Severe Result",
                "In Progress"
            ]
        }
    },
    template: `
        <tr class="survey-status">
              <td><div class="traffic-light" :style="style"></div></td>
              <td>{{status}}</td>
              <td>{{formattedDate}}</td>
        </tr>
    `,

    methods: {

    },
    computed: {
        surveyStatus(){
            return 'Text';
        },
        color() {
            if(this.result.trafficLight) {
                return this.result.trafficLight.color;

            } else {
                return "#adb6cc";
            }
        },
        formattedDate(){
            var date = new Date(this.result.scheduled_date).toLocaleDateString();

            if (!isNaN(date)) {
                date = new Date(this.result.scheduled_date.replace(/-/g, "/")).toLocaleDateString();
            }

            return isNaN(date) ? date : '';
        },
        status(){
            if(this.result.trafficLight && this.result.status !== 'Cancelled') {
                return this.severity[this.result.trafficLight.severity]
            } else {
                return this.result.status;
            }
        },
        style(){
            return "background: "+this.color+ "; width: 16px; height: 16px; border-radius: 100%; margin-bottom: -4px; margin-right: 4px; display: inline-block;";
        }
    },
    mounted() {

        },
    created() {

    }
});
Vue.component('survey-status-container', {
    props: {
        results: Array
    },
    data() {
        return {

        }
    },
    template: `
        <div class="survey-status result-area">
            <h4>Survey Status</h4>
            <table>
                <survey-status v-for="result in results" :result="result" v-bind:key="result.id" ></survey-status>
            </table>
        </div>
    `,

    methods: {

    },
    computed: {

    },
    mounted() {

    },
    created() {

    }
});

Vue.component('net-promoter-score', {
    props: {
        results: Object
    },
    data() {
        return {
            emojiRange: [
                [10, "🙂"],
                [8, "😐"],
                [6, "🙁"],
            ]
        }
    },
    template: `
        <div class="net-promoter-area result-area d-flex flex-column justify-content-around align-items-center">
            <span>Net Promoter</span>
            <div class="net-promoter-emoji">{{ emoji }}</div>
            <div class="net-promoter-score">{{ promoterScore }}</div>
        </div>

    `,

    methods: {},
    computed: {
        promoterScore() {
            return this.results.scores['Recommend'] !== undefined ? this.results.scores['Recommend'].raw : ''
        },
        emoji() {
            let emoji = "";
            for (let range of this.emojiRange) {
                if (this.results.scores['Recommend'] !== undefined && (range[0] >= this.results.scores['Recommend'].raw)){
                    emoji = range[1];
                }
            }
            return emoji;
        }
    },
    mounted() {

    },
    created() {

    }
});

Vue.component('t-score-container', {
    props: {
        results: Object,
        containerId: Number
    },
    template: `
        <div v-if="hasScores">
            <h2>{{title}}</h2>
            <div class="t-score-container result-area">
                <t-score  v-for="(scores, category) in results.scores" :container-id="containerId" :category="category" :scores="scores" :invert="true" v-bind:key="category" width="25%" style="display: inline-block"></t-score>
            </div>
        </div>

    `,
    computed: {
        title() {
            switch(this.containerId){
                case 0:
                    return "2 Week Survey"; // SurveyInstance::ITERATION_DAYS_OFFSET_1
                case 1:
                    return "6 Week Survey"; // SurveyInstance::ITERATION_DAYS_OFFSET_2
                case 2:
                    return "6 Month Survey"; // SurveyInstance::ITERATION_DAYS_OFFSET_3
            }
        },
        hasScores() {
            return (this.results.scores !== null);
        }
    }
});

//T score chart
Vue.component('t-score', {
    mixins: [
    ],
    props: {
        scores: Object,
        width: String,
        category: String,
        containerId: Number
    },
    data() {


        return {
            options: {
                'tooltip' : {
                    trigger: 'none'
                },
                legend: 'none',
                backgroundColor: 'transparent',
                bar: {groupWidth: "80%"},
                series: {
                    0: {
                        targetAxisIndex: 0
                    },
                },
                hAxis: {
                    textStyle: {
                        fontSize: 14,
                        bold: true
                    }
                },
                vAxis: {
                    baseline: 50,
                    viewWindow: {
                        min: 20,
                        max: 80
                    },
                    direction: 1,
                    ticks: [20, 30, 40, 50, 60, 70, 80],
                },
                annotations: {
                    color: 'black',
                    textStyle: {
                        fontSize: 14,
                        bold: true,
                        color: '#871b47',
                    },
                    stem: {
                        length: 10,
                        color: 'none'

                    },
                }
            },

        }
    },
    template: `
           <div v-if="scores.tScore" :id="chartId" :style="chartStyle"></div>
    `,

    methods: {
        draw() {
            if (this.scores.tScore) {
                let chart = new google.visualization.ColumnChart(document.getElementById(this.chartId));
                google.visualization.events.addListener(chart, 'select', ()=> chart.setSelection([])); //Make columns not selectable

                chart.draw(google.visualization.arrayToDataTable(this.chartData), this.options);
            }
        },

    },
    computed: {

        chartStyle() {
            return "width: " + this.width + "; height: 500px;";
        },
        chartData() {
            let data = [];
            data.push(['Category', 'T-Score', {role: 'style'}, {role: 'annotation'}]);
            data.push(
                [
                    this.category,
                    this.scores.tScore,
                    this.scores.color,
                    this.scores.tScore + " ± " + this.scores.standardError
                ]);
            return data;
        },
        chartId() {
            return this.category.replace(/ /g, "_")+this.containerId;
        },
    },
    mounted() {
        if (this.category === "Physical Function") {
            this.options.vAxis.direction = -1;
        }
        window.GoogleChartsLoadedPromise.then( this.draw );
    },
    created() {

    }
});
